export const getIssues = state => state.issue.issuesList;
export const getIssueDetails = state => state.issue.issueDetails;
